export default __webpack_public_path__ + "static/media/Belts.a97aed62.jpg";